<template>
  <section id="footer">
    <b-container class="footer" fluid>
        <b-row id="footer-box" class="py-3 justify-content-center">
          <p style="color:white;">
            © Copyright 2020 | Developed By: <span style="color:teal;"><b>Me</b></span>
          </p>
        </b-row>
    </b-container>
  </section>
</template>

<script>
// import Banner from '@/components/Home/BannerComponent.vue'

export default {
  name: 'Footer',
  components: {
      //
  }
}
</script>

